import { initializeApp } from 'firebase/app';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getFirestore, collection, addDoc, setDoc, doc, query, limit, getDocs, orderBy } from 'firebase/firestore';
import { getMockSensors, getMockSensorData, getMockGateways } from './mockData';

const firebaseConfig = {
  apiKey: "AIzaSyAqVWyjfjizGrefjrJQ0vVlKRr314En3JA",
  authDomain: "sensors-c3cf7.firebaseapp.com",
  projectId: "sensors-c3cf7",
  storageBucket: "sensors-c3cf7.appspot.com",
  messagingSenderId: "465874275955",
  appId: "1:465874275955:web:630ac254bb390b8073a406",
  measurementId: "G-MC5CBGKNM2"
};

// Initialize Firebase and Firestore
const appFirebase = initializeApp(firebaseConfig);
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

export const signInWithDsCustomToken = async (customToken) => {
  // Idempotent: if already signed in with same account, Firebase handles it
  await signInWithCustomToken(auth, customToken);
  return auth.currentUser;
};

/** 
 * Saves user interaction with sensor cards to Firestore using the new Modular API.
 * @param {Object} userData - User details provided as props in Home component.
 * @param {string} sensorTitle - The title of the sensor interacted with.
 */
const saveSensorInteraction = async (userData, sensorTitle) => {
  try {
    // Use the Modular SDK's `addDoc` method to add a document to a collection
    await addDoc(collection(db, 'sensorInteractions'), {
      sensorTitle,
      ...userData,
      timestamp: new Date()
    });
  } catch (error) {
    console.error("Error saving sensor interaction to Firestore:", error);
    throw new Error("Failed to save data.");
  }
};

export const addSensor = async (sensor) => {
  try {
    await setDoc(doc(db, 'sensors', sensor.id), sensor);
  } catch (error) {
    console.error('Error adding sensor:', error);
  }
};

export const getSensors = async () => {
  try {
    const sensorsSnapshot = await getDocs(collection(db, 'sensors'));
    const sensors = sensorsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return sensors.length ? sensors : getMockSensors();
  } catch (error) {
    console.error('Error getting sensors:', error);
    return getMockSensors();
  }
};

export const getGateways = async () => {
  try {
    const gatewaysSnapshot = await getDocs(collection(db, 'gateways'));
    const gateways = gatewaysSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return gateways.length ? gateways : getMockGateways();
  } catch (error) {
    console.error('Error getting gateways:', error);
    return getMockGateways();
  }
};

export const getSensorData = async (sensorId) => {
  try {
    const dataQuery = query(collection(db, 'sensors', sensorId, 'data'), orderBy('timestamp', 'desc'), limit(100));
    const dataSnapshot = await getDocs(dataQuery);
    const data = dataSnapshot.docs.map(doc => doc.data());
    return data.length ? data : getMockSensorData(sensorId);
  } catch (error) {
    console.error('Error getting sensor data:', error);
    return getMockSensorData(sensorId);
  }
};

export const addGateway = async (gateway) => {
  try {
    await setDoc(doc(db, 'gateways', gateway.id), gateway);
  } catch (error) {
    console.error('Error adding gateway:', error);
  }
};

const saveSensorDetails = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, 'sensorInteractions'), {
      ...formData,
      type: "sensorDetails",
      timestamp: new Date(),
    });
    console.log("Document written with ID: ", docRef.id);
    return docRef.id; // optionally return the document ID
  } catch (error) {
    console.error("Error adding document: ", error);
    throw new Error("Unable to save sensor details.");
  }
};

export { db, saveSensorInteraction, saveSensorDetails, appFirebase, auth }; 